import {ChangeEvent, FC, useCallback, useState} from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/InputBase";
import {styled} from "@mui/material/styles";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import Button from "@memaro/components/Button.tsx";
import {StaticDatePicker} from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/nl';
import {Dayjs} from 'dayjs'
import Typography from "@mui/material/Typography";
import Header from "@memaro/components/Header.tsx";
import Dialog from "@mui/material/Dialog";

export type SummaryProps = {
    name: string | undefined
    onChangeName: (name: string) => void
    dateOfBirth: Dayjs | null
    onChangeDateOfBirth: (date: Dayjs | null) => void
    dateOfDeath: Dayjs | null
    onChangeDateOfDeath: (date: Dayjs | null) => void
    editMode: boolean
}

const StyledInput = styled(Input)(({theme}) => ({
    fontWeight: 700,
    marginTop: '1rem',
    marginBottom: '0.5rem',
    fontSize: '3rem',
    fontFamily: 'inherit',
    border: '2px solid transparent',
    transition: 'border 0.3s',
    borderRadius: 10,
    ':hover': {
        border: `2px solid ${theme.palette.primary.light}`,
    },
    ':has(:focus)': {
        border: `2px solid ${theme.palette.primary.main}`,
    },
    'input': {
        borderRadius: 10,
        textAlign: 'center'
    }
}))

const StyledDate = styled(Typography)({
    margin: 0,
    padding: "5px 12px",
    fontFamily: 'inherit',
    fontSize: "14px"
})

const Summary: FC<SummaryProps> = ({name, onChangeName, dateOfBirth, onChangeDateOfBirth,dateOfDeath, onChangeDateOfDeath, editMode}) => {
    const [datePickerFor, setDatePickerFor] = useState<"dateOfBirth" | "dateOfDeath" | null>(null);

    const handleChangeName = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => onChangeName(event.target.value),
        [onChangeName]
    )

    const handleChangeDate = useCallback((date: Dayjs | null) => {
            if (datePickerFor == "dateOfBirth") {
                onChangeDateOfBirth(date)
            } else {
                onChangeDateOfDeath(date)
            }
        },
        [datePickerFor, onChangeDateOfBirth, onChangeDateOfDeath]
    )
    const handleOpenDateOfBirth = useCallback(() => setDatePickerFor("dateOfBirth"), [])
    const handleOpenDateOfDeath = useCallback(() => setDatePickerFor("dateOfDeath"), [])
    const handleClose = useCallback(() => setDatePickerFor(null), [])

    return (
        <Box>
            {editMode ? (
                <StyledInput value={name || ""} placeholder="[Naam]" onChange={handleChangeName}/>
            ) : (
                <Header>{name || ""}</Header>
            )}
            <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" height={50}>
                {editMode ? (
                    <Button onClick={handleOpenDateOfBirth}>{dateOfBirth?.format('LL') ?? '[Geboortedatum]'}</Button>
                ) : (
                    <StyledDate>{dateOfBirth?.format('LL')}</StyledDate>
                )}
                <Box marginLeft={1} marginRight={1}> - </Box>
                {editMode ? (
                    <Button onClick={handleOpenDateOfDeath}>{dateOfDeath?.format('LL') ?? '[Overlijdendatum]'}</Button>
                ) : (
                    <StyledDate>{dateOfDeath?.format('LL')}</StyledDate>
                )}
            </Box>
            {editMode ? (
                <Dialog open={datePickerFor != null} onClose={handleClose}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="nl">
                        <StaticDatePicker
                            onClose={handleClose}
                            defaultValue={datePickerFor == "dateOfBirth" ? dateOfBirth : dateOfDeath}
                            onChange={handleChangeDate}
                            views={['year', 'month' ,'day']}
                        />
                    </LocalizationProvider>
                </Dialog>
            ) : null}
        </Box>
    )
}

export default Summary
